module.exports = __webpack_public_path__ + "static/media/compact-logo.9adf116f.png";